/* GENERATED FILE */
import type { ReactElement } from "react";
import { Fragment } from "react";
import type { IconVariant } from "../lib";

export default new Map<IconVariant, ReactElement>([
	[
		"duocolor",
		<Fragment key={"duocolor"}>
			<path
				opacity="0.4"
				d="M18 15L15 18M18 15L15 12M18 15H13.4C11.1598 15 10.0397 15 9.18404 14.564C8.43139 14.1805 7.81947 13.5686 7.43597 12.816C7 11.9603 7 10.8402 7 8.6V6.99992"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<rect
				x="2"
				y="2"
				width="20"
				height="20"
				rx="5"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"duotone",
		<Fragment key={"duotone"}>
			<rect
				opacity="0.12"
				x="2"
				y="2"
				width="20"
				height="20"
				rx="5"
				fill="currentColor"
			/>
			<path
				d="M18 15L15 18M18 15L15 12M18 15H14.5C12.1703 15 11.0054 15 10.0866 14.6194C8.86144 14.1119 7.88807 13.1386 7.3806 11.9134C7 10.9946 7 9.82971 7 7.5V7.5V6.99992M10 22H14C16.8003 22 18.2004 22 19.27 21.455C20.2108 20.9757 20.9757 20.2108 21.455 19.27C22 18.2004 22 16.8003 22 14V10C22 7.19974 22 5.79961 21.455 4.73005C20.9757 3.78924 20.2108 3.02433 19.27 2.54497C18.2004 2 16.8003 2 14 2H10C7.19974 2 5.79961 2 4.73005 2.54497C3.78924 3.02433 3.02433 3.78924 2.54497 4.73005C2 5.79961 2 7.19974 2 10V14C2 16.8003 2 18.2004 2.54497 19.27C3.02433 20.2108 3.78924 20.9757 4.73005 21.455C5.79961 22 7.19974 22 10 22Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"filled",
		<Fragment key={"filled"}>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M3.98005 1.79497C5.04961 1.25 6.44974 1.25 9.25 1.25H14.75C17.5503 1.25 18.9504 1.25 20.02 1.79497C20.9608 2.27433 21.7257 3.03924 22.205 3.98005C22.75 5.04961 22.75 6.44974 22.75 9.25V14.75C22.75 17.5503 22.75 18.9504 22.205 20.02C21.7257 20.9608 20.9608 21.7257 20.02 22.205C18.9504 22.75 17.5503 22.75 14.75 22.75H9.25C6.44974 22.75 5.04961 22.75 3.98005 22.205C3.03924 21.7257 2.27433 20.9608 1.79497 20.02C1.25 18.9504 1.25 17.5503 1.25 14.75V9.25C1.25 6.44974 1.25 5.04961 1.79497 3.98005C2.27433 3.03924 3.03924 2.27433 3.98005 1.79497ZM15.5303 18.5303C15.2374 18.8232 14.7626 18.8232 14.4697 18.5303C14.1768 18.2374 14.1768 17.7626 14.4697 17.4697L16.1893 15.75H13.4H13.367H13.367C12.2749 15.75 11.4094 15.75 10.7117 15.693C9.99834 15.6347 9.39472 15.5131 8.84354 15.2323C7.94978 14.7769 7.22312 14.0502 6.76772 13.1565C6.48688 12.6053 6.36527 12.0017 6.30699 11.2883C6.24999 10.5906 6.24999 9.72515 6.25 8.63301V8.633V8.6V6.99992C6.25 6.58571 6.58579 6.24992 7 6.24992C7.41421 6.24992 7.75 6.58571 7.75 6.99992V8.6C7.75 9.73248 7.75058 10.5367 7.80201 11.1661C7.85271 11.7867 7.94909 12.171 8.10423 12.4755C8.41582 13.087 8.913 13.5842 9.52453 13.8958C9.829 14.0509 10.2133 14.1473 10.8339 14.198C11.4633 14.2494 12.2675 14.25 13.4 14.25H16.1893L14.4697 12.5303C14.1768 12.2374 14.1768 11.7626 14.4697 11.4697C14.7626 11.1768 15.2374 11.1768 15.5303 11.4697L18.5303 14.4697C18.8232 14.7626 18.8232 15.2374 18.5303 15.5303L15.5303 18.5303Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
	[
		"gestalt",
		<Fragment key={"gestalt"}>
			<path
				d="M18 15L15 18M18 15L15 12M18 15H14.5C12.1703 15 11.0054 15 10.0866 14.6194C8.86144 14.1119 7.88807 13.1386 7.3806 11.9134C7 10.9946 7 9.82971 7 7.5V7.5V6.99992M10 22H14C16.8003 22 18.2004 22 19.27 21.455C20.2108 20.9757 20.9757 20.2108 21.455 19.27C22 18.2004 22 16.8003 22 14V10C22 7.19974 22 5.79961 21.455 4.73005C20.9757 3.78924 20.2108 3.02433 19.27 2.54497C18.2004 2 16.8003 2 14 2H10C7.19974 2 5.79961 2 4.73005 2.54497C3.78924 3.02433 3.02433 3.78924 2.54497 4.73005C2 5.79961 2 7.19974 2 10V14C2 16.8003 2 18.2004 2.54497 19.27C3.02433 20.2108 3.78924 20.9757 4.73005 21.455C5.79961 22 7.19974 22 10 22Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"line",
		<Fragment key={"line"}>
			<path
				d="M18 15L15 18M18 15L15 12M18 15H14.5C12.1703 15 11.0054 15 10.0866 14.6194C8.86144 14.1119 7.88807 13.1386 7.3806 11.9134C7 10.9946 7 9.82971 7 7.5V7.5V6.99992M10 22H14C16.8003 22 18.2004 22 19.27 21.455C20.2108 20.9757 20.9757 20.2108 21.455 19.27C22 18.2004 22 16.8003 22 14V10C22 7.19974 22 5.79961 21.455 4.73005C20.9757 3.78924 20.2108 3.02433 19.27 2.54497C18.2004 2 16.8003 2 14 2H10C7.19974 2 5.79961 2 4.73005 2.54497C3.78924 3.02433 3.02433 3.78924 2.54497 4.73005C2 5.79961 2 7.19974 2 10V14C2 16.8003 2 18.2004 2.54497 19.27C3.02433 20.2108 3.78924 20.9757 4.73005 21.455C5.79961 22 7.19974 22 10 22Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"mono",
		<Fragment key={"mono"}>
			<path
				opacity="0.32"
				d="M9.25 1.25C6.44974 1.25 5.04961 1.25 3.98005 1.79497C3.03924 2.27433 2.27433 3.03924 1.79497 3.98005C1.25 5.04961 1.25 6.44974 1.25 9.25V14.75C1.25 17.5503 1.25 18.9504 1.79497 20.02C2.27433 20.9608 3.03924 21.7257 3.98005 22.205C5.04961 22.75 6.44974 22.75 9.25 22.75H14.75C17.5503 22.75 18.9504 22.75 20.02 22.205C20.9608 21.7257 21.7257 20.9608 22.205 20.02C22.75 18.9504 22.75 17.5503 22.75 14.75V9.25C22.75 6.44974 22.75 5.04961 22.205 3.98005C21.7257 3.03924 20.9608 2.27433 20.02 1.79497C18.9504 1.25 17.5503 1.25 14.75 1.25H9.25Z"
				fill="currentColor"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M14.4697 18.5304C14.7626 18.8233 15.2374 18.8233 15.5303 18.5304L18.5303 15.5304C18.8232 15.2375 18.8232 14.7626 18.5303 14.4697L15.5303 11.4697C15.2374 11.1769 14.7626 11.1769 14.4697 11.4697C14.1768 11.7626 14.1768 12.2375 14.4697 12.5304L16.1893 14.2501H13.4C12.2675 14.2501 11.4633 14.2495 10.8339 14.1981C10.2133 14.1474 9.829 14.051 9.52453 13.8959C8.913 13.5843 8.41582 13.0871 8.10423 12.4755C7.94909 12.1711 7.85271 11.7868 7.80201 11.1662C7.75058 10.5368 7.75 9.73256 7.75 8.60008V7C7.75 6.58579 7.41421 6.25 7 6.25C6.58579 6.25 6.25 6.58579 6.25 7V8.60008L6.25 8.63308C6.24999 9.72522 6.24999 10.5907 6.30699 11.2883C6.36527 12.0017 6.48688 12.6054 6.76772 13.1565C7.22312 14.0503 7.94978 14.777 8.84355 15.2324C9.39472 15.5132 9.99835 15.6348 10.7117 15.6931C11.4094 15.7501 12.2749 15.7501 13.367 15.7501H13.4H16.1893L14.4697 17.4698C14.1768 17.7626 14.1768 18.2375 14.4697 18.5304Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
]);
